
import styles from './features_listing.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'

function FeaturesListing(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.features_listing}>
		<ScrollAnimation styles={styles}>
			<div className={styles.listing_container}>
				<div className={styles.intro_wrapper}>		
					{fields.title && <h2>{fields.title}</h2>}
					<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
				</div>
				<div className={styles.listing_wrapper}>
					{fields.features && fields.features.map((feature, i) => {
						return <div key={i} className={styles.feature_wrapper}>
							<div className={styles.icon}>
								{feature.icon && <Image {...feature.icon} />}
							</div>
							<div className={styles.content_wrapper}>
								<h3>{feature.title}</h3>
								<div className={styles.content} dangerouslySetInnerHTML={{__html: feature.content}}></div>
							</div>
						</div>
					})}
				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default FeaturesListing